import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'attachment/<id>';

export function useAttachmentQuery({
	id,
	enabled,
	impersonationContext,
}: {
	id: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();

	return useQuery({
		enabled,
		queryFn: async () => {
			return userSession.webServiceHelper.callAsync<Api.IFileAttachment>(
				Api.ImpersonationBroker.composeApiUrl({ impersonationContext, urlPath: `attachment/${id}` }),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, impersonationContext, id],
		staleTime: 1000 * 60 * 5,
	});
}

export function setAttachmentQueryData({
	id,
	impersonationContext,
	data,
}: {
	id: string;
	impersonationContext?: Api.IImpersonationContext;
	data: Api.IFileAttachment;
}) {
	reactQueryClient.setQueryData([BASE_QUERY_KEY, impersonationContext, id], data);
}
